export enum OrderSideEnum {
  Buy = 1,
  Sell = 2,
  Short = 5,
  None = 255,
}
